
export const selectCopiedAssets = state => state.layer.copiedAssets
